import {UIMessage, useChat, UseChatOptions} from '@ai-sdk/react';
import {ApiDomain, useKeyplayToken} from '../../../context/ApiContext';
import SuperJSON from 'superjson';
import {DefaultChatTransport} from 'ai';

export function useAiChat({
  path,
  setPreviousResponseId,
  ...useChatOptions
}: {
  path: string;
  setPreviousResponseId: (responseId: string | undefined) => void;
} & UseChatOptions<UIMessage>) {
  const token = useKeyplayToken();
  return useChat({
    transport: new DefaultChatTransport({
      api: `${ApiDomain}/${path}`,
      headers: () => ({
        Authorization: `Bearer ${token}`,
      }),
      prepareSendMessagesRequest: ({id, messages, body}) => ({
        body: SuperJSON.serialize({
          id,
          message: messages[messages.length - 1],
          ...(body ? body : {}),
        }),
      }),
    }),

    onData: (part) => {
      if (part.type === 'data-response-id') {
        const responseId = (part.data as {responseId?: string})?.responseId;
        if (responseId) {
          setPreviousResponseId(responseId);
        }
      }
    },

    ...useChatOptions,
  });
}
